import React from 'react';
import { useSelector } from 'react-redux';
import Nav from '../components/Nav/Nav';
import MovieMain from '../components/Main/MovieMain';
import Movie from '../components/Movie/Movie';

const PopularAndNew = () => {
  const trending = useSelector((state) => state.trending);
  const popular = useSelector((state) => state.popular);
  const tvTrending = useSelector((state) => state.tvTrending);
  const tvPopular = useSelector((state) => state.tvPopular);
  return (
    <>
      <Nav />
      <MovieMain />
      <div className="main-movie-section">
        <Movie fetchUrl={trending} title="Trending Movies" />
      </div>
      <div className="main-movie-section">
        <Movie fetchUrl={popular} title="Popular Movies" />
      </div>
      <div className="main-movie-section">
        <Movie fetchUrl={tvTrending} title="Trending Tv Shows" />
      </div>
      <div className="main-movie-section">
        <Movie fetchUrl={tvPopular} title="Poular Tv Shows" />
      </div>
    </>
  );
};

export default PopularAndNew;
